<div class="">
    <div class="flex justify-content-between align-items-center mb-4">
        <div class="flex align-items-center gap-3">
            <input type="text" pInputText placeholder="Search forms..." [formControl]="searchControl" class="w-20rem" />
            <p-dropdown [options]="versionFilterOptions" [formControl]="versionFilterControl"
                placeholder="Most Relevant" optionLabel="label" optionValue="value" [showClear]="false">
            </p-dropdown>
            <p-dropdown [options]="statusFilterOptions" [formControl]="statusFilterControl" placeholder="All Status"
                optionLabel="label" optionValue="value" [showClear]="false">
            </p-dropdown>


        </div>
    </div>

    <!-- Sorting Controls -->
    <div class="flex flex-wrap gap-2 mb-4 p-3 border-round surface-border border-1">
        <div class="flex align-items-center gap-2">
            <span class="text-sm font-medium">Sort by:</span>
        </div>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'identifier'" (click)="onCardSort('identifier')">
            Identifier
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'identifier' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'name'" (click)="onCardSort('name')">
            Name
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'name' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'version'" (click)="onCardSort('version')">
            Version
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'version' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'status'" (click)="onCardSort('status')">
            Status
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'status' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
        <button pButton class="p-button-outlined p-button-sm"
            [class.p-button-secondary]="pageOptions.orderBy === 'createdAt'" (click)="onCardSort('createdAt')">
            Created
            <i class="pi ml-1" [ngClass]="pageOptions.orderBy === 'createdAt' ? 
                         (pageOptions.orderDir === OrderDir.ASC ? 'pi-sort-up' : 'pi-sort-down') : 
                         'pi-sort'"></i>
        </button>
    </div>

    <!-- Cards Grid -->
    <div class="flex flex-column gap-4" *ngIf="formPage.data && formPage.data.length > 0">
        <div class="surface-card border-round-xl shadow-2 p-4 cursor-pointer hover:shadow-4 hover:border-teal-300 hover:bg-teal-50 transition-all transition-duration-200"
            *ngFor="let form of formPage.data" (click)="startUpdateForm(form.id)">
            <div class="flex align-items-center gap-4">
                <!-- Form Icon -->
                <div class="flex align-items-center justify-content-center w-4rem h-4rem border-round-lg surface-100">
                    <i class="pi pi-file-edit text-3xl" [ngClass]="{
                        'text-green-600': form.isActive && form.status === 'PUBLISHED',
                        'text-orange-600': form.isActive && form.status === 'DRAFT',
                        'text-400': !(form.isActive && (form.status === 'PUBLISHED' || form.status === 'DRAFT'))
                    }"></i>
                </div>

                <!-- Form Details -->
                <div class="flex-1 flex flex-column gap-2">
                    <!-- Header with Name and Status -->
                    <div class="flex justify-content-between align-items-start">
                        <div class="flex flex-column gap-1 flex-1">
                            <div class="flex align-items-center gap-2">
                                <h3 class="m-0 text-xl font-semibold text-900" [title]="form.name">{{ form.name.length >
                                    50
                                    ? (form.name | slice:0:50) + '...' : form.name }}</h3>
                                <!-- Active Published Tick -->
                                <div class="flex align-items-center gap-1"
                                    *ngIf="form.isActive && form.status === 'PUBLISHED'">
                                    <i class="pi pi-check-circle text-green-600 font-bold" pTooltip="Active"></i>
                                    <span class="text-green-600 text-sm font-medium">Active</span>
                                </div>
                                <!-- Inactive Published -->
                                <div class="flex align-items-center gap-1"
                                    *ngIf="!form.isActive && form.status === 'PUBLISHED'">
                                    <i class="pi pi-times-circle text-400" pTooltip="Inactive"></i>
                                    <span class="text-400 text-sm font-medium">Inactive</span>
                                </div>
                                <!-- Latest Draft Badge -->
                                <span class="px-2 py-1 border-round text-xs font-medium bg-blue-100 text-blue-700"
                                    *ngIf="form.isActive && form.status === 'DRAFT'">
                                    Latest Draft
                                </span>
                            </div>
                            <small class="text-600" [title]="form.description" *ngIf="form.description">{{
                                form.description.length > 80 ? (form.description | slice:0:80) + '...' :
                                form.description }}</small>
                        </div>
                        <span class="px-3 py-1 border-round-lg text-sm font-medium ml-4" [ngClass]="{
                          'bg-orange-100 text-orange-700': form.status === 'DRAFT',
                          'bg-green-100 text-green-700': form.status === 'PUBLISHED',
                          'bg-gray-100 text-gray-700': form.status === 'ARCHIVED'
                        }">
                            {{ form.status }}
                        </span>
                    </div>

                    <!-- Form Meta Info -->
                    <div class="flex align-items-center gap-6 text-sm text-600">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-tag"></i>
                            <span class="font-mono">{{ form.identifier }}</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-code"></i>
                            <span class="font-medium">v{{ form.version }}</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-calendar"></i>
                            <span>{{ form.createdAt | dynamicDate:'shortDate' }}</span>
                        </div>
                        <div class="flex align-items-center gap-2" *ngIf="form.creator">
                            <i class="pi pi-user"></i>
                            <span>{{ form.creator.firstName }} {{ form.creator.lastName }}</span>
                        </div>
                        <div class="flex align-items-center gap-2" *ngIf="!form.creator">
                            <i class="pi pi-user"></i>
                            <span>No creator</span>
                        </div>
                    </div>
                </div>

                <!-- Actions -->
                <div class="flex gap-2" (click)="$event.stopPropagation()">
                    <button pButton icon="pi pi-eye" class="p-button-outlined p-button-rounded p-button-sm"
                        pTooltip="Preview Form" (click)="openSurveyPreviewDialog(form)"></button>
                    <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-sm" pTooltip="Edit Form"
                        (click)="startUpdateForm(form.id)"></button>
                </div>
            </div>
        </div>
    </div>

    <!-- Empty State -->
    <div class="text-center py-8" *ngIf="!formPage.data || formPage.data.length === 0">
        <div class="flex flex-column align-items-center gap-3">
            <i class="pi pi-file text-6xl text-400"></i>
            <h3 class="text-500 m-0">No forms found</h3>
            <p class="text-500 m-0">Try adjusting your search or filters</p>
        </div>
    </div>

    <!-- Pagination -->
    <div class="flex justify-content-center mt-4" *ngIf="formPage.data && formPage.data.length > 0">
        <p-paginator [rows]="pageOptions.limit" [totalRecords]="formPage.total"
            [first]="(pageOptions.page - 1) * pageOptions.limit" (onPageChange)="onPaginatorPageEvent($event)"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} forms">
        </p-paginator>
    </div>
</div>

<!-- Survey Preview Dialog -->
<p-dialog #previewDialog (onShow)="previewDialog.maximize()" [(visible)]="showSurveyPreviewDialog" [modal]="true"
    [closable]="false" [resizable]="false" [draggable]="false" [maximizable]="false" header="Form Preview"
    styleClass="fullscreen-dialog" [appendTo]="'body'" [style]="{width: '100vw', height: '100vh'}"
    (onHide)="closeSurveyPreviewDialog()">

    <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-center w-full">
            <span class="text-xl font-semibold">Form Preview</span>
            <div class="flex gap-2">
                <button pButton type="button" [class]="isMobilePreview ? 'p-button-primary' : 'p-button-outlined'"
                    [label]="isMobilePreview ? 'Desktop View' : 'Mobile View'"
                    [icon]="isMobilePreview ? 'pi pi-desktop' : 'pi pi-mobile'" (click)="toggleMobilePreview()">
                </button>
                <button pButton type="button" label="Close" icon="pi pi-times" class="p-button-text"
                    (click)="closeSurveyPreviewDialog()"></button>
            </div>
        </div>
    </ng-template>

    <!-- Survey Preview Container -->
    <div class="survey-preview-container flex flex-column h-full">
        <!-- Info Header -->
        <div class="flex align-items-center gap-2 p-3 bg-blue-50 border-round mb-3">
            <i class="pi pi-info-circle text-blue-500"></i>
            <small class="text-700">
                This is a preview of your form. You can interact with it to see how it will behave for users.
            </small>
        </div>

        <!-- Scrollable Survey Container -->
        <div class="flex-1 overflow-auto flex justify-content-center">
            <div [class]="'border-1 surface-border border-round p-3 transition-all transition-duration-300 ' + 
                (isMobilePreview ? 'mobile-preview-container' : 'desktop-preview-container')"
                [style]="{'min-height': 'calc(100vh - 200px)'}">
                <survey *ngIf="surveyPreviewModel" [model]="surveyPreviewModel"></survey>
            </div>
        </div>
    </div>
</p-dialog>

<p-dialog header="Edit Form Details" [(visible)]="showUpdateFormDialog" [modal]="true"
    [style]="{ width: 'min(50vw, 800px)', minHeight: '60vh', maxWidth: '90vw' }" [draggable]="false" [resizable]="false"
    [appendTo]="'body'" [baseZIndex]="10000" (onHide)="stopUpdateForm()">
    <app-crud-forms [crudMode]="CrudFormMode.UPDATE" [formId]="updateFormId"
        (onSuccess)="onUpdateFormSuccess()"></app-crud-forms>
</p-dialog>